const API_URL =
  process.env.REACT_APP_API_URL ?? "https://festa-backend.onrender.com/api";
const NODE_ENV = process.env.NODE_ENV;

export { API_URL, NODE_ENV };
